import { motion } from "framer-motion";
import { Camera, Sparkles, Wrench, IndianRupee } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: Camera,
    title: "Snap · Upload",
    desc: "Photograph your damaged vehicle from any angle. Upload RC, DL, policy — our OCR extracts every field in seconds.",
    tint: "from-blue-700 to-blue-900",
  },
  {
    n: "02",
    icon: Sparkles,
    title: "AI assesses damage",
    desc: "Gemini Vision analyses your photos, classifies severity, and predicts a realistic ₹ settlement band before you file.",
    tint: "from-orange-500 to-orange-600",
  },
  {
    n: "03",
    icon: Wrench,
    title: "Cashless repair",
    desc: "We route you to the nearest partner garage, coordinate the survey, and negotiate the estimate on your behalf.",
    tint: "from-pink-500 to-pink-700",
  },
  {
    n: "04",
    icon: IndianRupee,
    title: "Settled — fast",
    desc: "Average settlement in 12-15 days vs the industry's 45+. Track every step live in your dashboard, get paid faster.",
    tint: "from-emerald-500 to-emerald-700",
  },
];

export default function HowItWorks() {
  return (
    <section className="py-24 relative mesh-subtle" data-testid="how-it-works">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-orange-600 dark:text-orange-400 mb-2">How it works</div>
          <h2 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 dark:text-white">
            Four steps. Zero paperwork trauma.
          </h2>
        </div>

        <div className="relative grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="card-premium p-6 relative group"
              data-testid={`step-${s.n}`}
            >
              <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${s.tint} flex items-center justify-center mb-4 shadow-lg`}>
                <s.icon className="w-6 h-6 text-white" />
              </div>
              <div className="text-[10px] font-mono font-bold text-slate-400 dark:text-slate-500 tracking-widest mb-2">{s.n}</div>
              <h3 className="font-heading font-bold text-lg text-slate-900 dark:text-white mb-2">{s.title}</h3>
              <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">{s.desc}</p>
              {i < STEPS.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-px bg-gradient-to-r from-slate-300 to-transparent dark:from-slate-700" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
